<template>
  <a-modal :open="open" @cancel="closeForm" class="modal-no-padding edit-reference-modal">
    <div class="modal-no-padding__header">
      <h2>Редактирование эталонного профиля</h2>
    </div>
    <a-divider style="margin: 16px 0" />
    <div class="modal-no-padding__body">
      <span class="label">Название</span>
      <a-input v-model:value="form.title" :status="statusError.referenceTitle ? 'error' : ''"/>
    </div>

    <template #footer>
      <a-divider style="margin: 16px 0" />
      <div class="modal-no-padding__footer">
        <div class="action-buttons">
          <a-row justify="end" :gutter="8">
            <a-col>
              <a-button class="secondary-button" @click="closeForm">Отменить</a-button>
            </a-col>
            <a-col>
              <a-button class="primary-button" :disabled="!saveButtonActive" :loading="modalActionLoading" @click="handleEditReference">Сохранить</a-button>
            </a-col>
          </a-row>
        </div>
      </div>
    </template>
  </a-modal>
</template>

<script>

import {useStore} from "vuex";
import {reactive, ref} from "@vue/runtime-core";
import {message} from "ant-design-vue";
import {computed} from "@vue/reactivity";

export default {
  props: {
    open: Boolean,
    reference: Object
  },
  emits: ['submitted', 'close'],
  setup(props, context) {
    const store = useStore();
    const modalActionLoading = ref(false);

    const form = reactive({
      id: props.reference.id,
      title: props.reference.title ?? '',
    });

    const statusError = reactive({
      referenceTitle: false,
    });

    const closeForm = () => {
      context.emit('close');
    }

    const saveButtonActive = computed(() => form.title && form.title.length > 5 && form.title !== props.reference.title);

    const handleEditReference = () => {
      if (!form.title || form.title.length < 5) {
        statusError.referenceTitle = true;
        return;
      } else {
        statusError.referenceTitle = false;
      }

      modalActionLoading.value = true;

      store.dispatch('references/updateReferenceTitle', form).then(() => {
        message.success('Название эталонного профиля обновлено');
        context.emit('submitted');
      });
    }

    return {
      modalActionLoading,
      statusError,
      closeForm,
      handleEditReference,
      form,
      saveButtonActive
    }
  }
}
</script>

<style scoped lang="scss">

.edit-reference-modal {
  h2 {
    margin: 0;
    font-weight: 600;
    font-size: 16px;
    line-height: 120%;
  }

  .label {
    font-weight: 400;
    font-size: 14px;
    line-height: 120%;
    color: rgba(0, 0, 0, 0.65);
  }
}
</style>
